import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface LightingProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Lighting: React.FC<LightingProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [lighting, setLighting] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Lighting'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Lighting: v } } })
    );
    const label = 'Lighting';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={lighting}
                />
            ) : (
                <TextBox
                    value={lighting ?? ''}
                    onChange={(value) => setLighting(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
